module.exports = __webpack_public_path__ + "static/media/baas.981024b9.png";